// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mobileCartLineContainerStyles } from "@keller/App/Components/Cart/CartContainerLayout";
import { cardStyles } from "@keller/Overrides/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import { hideElementOnPrint, mergeWithCss } from "@keller/XDL/Utilities";
import { css } from "styled-components";

cardStyles.notesStyles = {
    ...mergeWithCss(cardStyles.notesStyles, {
        css: css`
            ${hideElementOnPrint}
        `,
    }),
};
cardStyles.lineNoteWrapperOnPrint = {
    css: css`
        display: none;
        @media print {
            display: flex;
        }
    `,
};
cardStyles.notesStylesOnPrint = {
    extendedStyles: {
        heading: {
            css: css`
                @media print {
                    text-transform: capitalize;
                    min-width: 61px;
                }
            `,
        },
    },
};
cardStyles.cartLineContainerMobileStyles = {
    peripheralActionsLeftOnPrint: {
        ...mergeWithCss(mobileCartLineContainerStyles.peripheralActionsLeftOnPrint, {
            css: css`
                @media print {
                    &&&& {
                        &,
                        & > span {
                            line-height: 1.5 !important;
                        }
                    }
                }
            `,
        }),
    },
};
